import CONSTS from '../constants'
import Component from './component'

export class CartIcon extends Component {
  constructor(ctx, ev) {
    super(ctx, ev)

    // classes extensions
    Object.assign(this.classes, {
      notification: '.js-cart-icon-notification',
      number: '.js-cart-icon-notification-number',
      showLoginLink: '.js-cart-icon-show-login',
    })

    const RADIX = 10

    this.cartQuantity = window.parseInt(this.$ctx.data('cart-quantity'), RADIX)
    this.maxNumber = 999

    this.$notification = this.$ctx.find(this.classes.notification)
    this.$number = this.$ctx.find(this.classes.number)

    this.displayNumber()
    this.bindShowLogin()
    this.listenToEvents()
  }

  bindShowLogin() {
    this.$showLoginLink = this.$ctx.find(this.classes.showLoginLink)

    if (this.$showLoginLink.length > 0) {
      this.$showLoginLink.on('click', (event) => {
        event.preventDefault()

        this.ev.emit(CONSTS.EVENTS.SHOW_LOGIN)
      })
    }
  }

  displayNumber() {
    if (this.cartQuantity > this.maxNumber) {
      this.$number.html(this.maxNumber)
      this.$notification.removeClass(this.classStates.hidden)
    } else if (this.cartQuantity > 0) {
      this.$number.html(this.cartQuantity)
      this.$notification.removeClass(this.classStates.hidden)
    } else if (this.cartQuantity === 0) {
      this.$notification.addClass(this.classStates.hidden)
    }
  }

  listenToEvents() {
    this.ev.on(
      CONSTS.EVENTS.UPDATE_CART_QUANTITY,
      (delta, absolute = false) => {
        if (absolute) {
          this.cartQuantity = delta
        } else {
          this.cartQuantity += delta
        }

        this.displayNumber()
      }
    )
  }

  onResize() {
    // noop
  }
}
